var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 6",
    width: 900,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 9,
    height: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#DB0D20",
    y: 3,
    width: 9,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#018DE9",
    y: 2,
    width: 9,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia);
export default __webpack_public_path__ + "static/media/russia.575e5c810b4acf3aee9099182830658d.svg";
export { ForwardRef as ReactComponent };